import script from "./BlogComment.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogComment.vue?vue&type=script&setup=true&lang=js"

import "./BlogComment.vue?vue&type=style&index=0&id=6a0e219c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a0e219c"]])

export default __exports__